// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const ApiKeyImportRow = __t.object("ApiKeyImportRow", {
  id: __t.string(),
  apiKey: __t.string(),
  userId: __t.string(),
  organizationId: __t.string(),
  product: __t.string(),
  isPowerOnProPlus: __t.option(__t.bool()),
  createdAt: __t.option(__t.timestamp()),
});
export type ApiKeyImportRow = __Infer<typeof ApiKeyImportRow>;

export const ApiKeys = __t.object("ApiKeys", {
  id: __t.string(),
  apiKey: __t.string(),
  userId: __t.string(),
  organizationId: __t.string(),
  product: __t.string(),
  isPowerOnProPlus: __t.option(__t.bool()),
  createdAt: __t.option(__t.timestamp()),
});
export type ApiKeys = __Infer<typeof ApiKeys>;

export const AuthBackend = __t.object("AuthBackend", {
  id: __t.string(),
  identity: __t.identity(),
  ready: __t.bool(),
});
export type AuthBackend = __Infer<typeof AuthBackend>;

export const AuthLogs = __t.object("AuthLogs", {
  id: __t.string(),
  userId: __t.string(),
  email: __t.string(),
  event: __t.string(),
  ipAddress: __t.string(),
  userAgent: __t.string(),
  createdAt: __t.string(),
});
export type AuthLogs = __Infer<typeof AuthLogs>;

export const AuthStorage = __t.object("AuthStorage", {
  id: __t.string(),
  pk: __t.string(),
  sk: __t.string(),
  value: __t.string(),
  expiry: __t.option(__t.f64()),
});
export type AuthStorage = __Infer<typeof AuthStorage>;

export const GlaciOpportunities = __t.object("GlaciOpportunities", {
  id: __t.string(),
  organizationId: __t.string(),
  name: __t.string(),
  description: __t.option(__t.string()),
  icon: __t.option(__t.string()),
  category: __t.option(__t.string()),
  conditions: __t.string(),
  author: __t.string(),
  rejectPlaybookId: __t.option(__t.string()),
  priority: __t.i32(),
  isActive: __t.bool(),
  isPromotional: __t.bool(),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type GlaciOpportunities = __Infer<typeof GlaciOpportunities>;

export const GlaciOpportunityImportRow = __t.object("GlaciOpportunityImportRow", {
  id: __t.string(),
  organizationId: __t.string(),
  name: __t.string(),
  description: __t.option(__t.string()),
  icon: __t.option(__t.string()),
  category: __t.option(__t.string()),
  conditions: __t.string(),
  author: __t.string(),
  rejectPlaybookId: __t.option(__t.string()),
  priority: __t.i32(),
  isActive: __t.bool(),
  isPromotional: __t.bool(),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type GlaciOpportunityImportRow = __Infer<typeof GlaciOpportunityImportRow>;

export const GlaciOrgSync = __t.object("GlaciOrgSync", {
  organizationId: __t.string(),
  publishedUpdatedAt: __t.timestamp(),
  publishedAt: __t.timestamp(),
  status: __t.string(),
  error: __t.option(__t.string()),
});
export type GlaciOrgSync = __Infer<typeof GlaciOrgSync>;

export const GlaciPlaybookImportRow = __t.object("GlaciPlaybookImportRow", {
  id: __t.string(),
  organizationId: __t.string(),
  userId: __t.string(),
  name: __t.string(),
  description: __t.option(__t.string()),
  icon: __t.option(__t.string()),
  category: __t.option(__t.string()),
  workflowName: __t.string(),
  nodes: __t.string(),
  connections: __t.string(),
  pinData: __t.option(__t.string()),
  author: __t.string(),
  executionType: __t.string(),
  version: __t.string(),
  isActive: __t.bool(),
  isVisible: __t.bool(),
  isOnHomeView: __t.bool(),
  requiresAccount: __t.bool(),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type GlaciPlaybookImportRow = __Infer<typeof GlaciPlaybookImportRow>;

export const GlaciPlaybookSync = __t.object("GlaciPlaybookSync", {
  playbookId: __t.string(),
  organizationId: __t.string(),
  publishedUpdatedAt: __t.timestamp(),
  publishedAt: __t.timestamp(),
  status: __t.string(),
  error: __t.option(__t.string()),
});
export type GlaciPlaybookSync = __Infer<typeof GlaciPlaybookSync>;

export const GlaciPlaybooks = __t.object("GlaciPlaybooks", {
  id: __t.string(),
  organizationId: __t.string(),
  userId: __t.string(),
  name: __t.string(),
  description: __t.option(__t.string()),
  icon: __t.option(__t.string()),
  category: __t.option(__t.string()),
  workflowName: __t.string(),
  nodes: __t.string(),
  connections: __t.string(),
  pinData: __t.option(__t.string()),
  author: __t.string(),
  executionType: __t.string(),
  version: __t.string(),
  isActive: __t.bool(),
  isVisible: __t.bool(),
  isOnHomeView: __t.bool(),
  requiresAccount: __t.bool(),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type GlaciPlaybooks = __Infer<typeof GlaciPlaybooks>;

export const GlaciTagImportRow = __t.object("GlaciTagImportRow", {
  id: __t.string(),
  organizationId: __t.string(),
  tagId: __t.string(),
  name: __t.string(),
  color: __t.option(__t.string()),
});
export type GlaciTagImportRow = __Infer<typeof GlaciTagImportRow>;

export const GlaciTags = __t.object("GlaciTags", {
  id: __t.string(),
  organizationId: __t.string(),
  tagId: __t.string(),
  name: __t.string(),
  color: __t.option(__t.string()),
});
export type GlaciTags = __Infer<typeof GlaciTags>;

export const IdentityLinkImportRow = __t.object("IdentityLinkImportRow", {
  identity: __t.identity(),
  userId: __t.string(),
  linkedAt: __t.timestamp(),
});
export type IdentityLinkImportRow = __Infer<typeof IdentityLinkImportRow>;

export const IdentityLinks = __t.object("IdentityLinks", {
  identity: __t.identity(),
  userId: __t.string(),
  linkedAt: __t.timestamp(),
});
export type IdentityLinks = __Infer<typeof IdentityLinks>;

export const InviteDetailsRow = __t.object("InviteDetailsRow", {
  organizationId: __t.string(),
  organizationName: __t.string(),
  organizationLogo: __t.string(),
  inviterName: __t.string(),
  inviterEmail: __t.string(),
  invitedEmail: __t.string(),
});
export type InviteDetailsRow = __Infer<typeof InviteDetailsRow>;

export const LicenseLookupRow = __t.object("LicenseLookupRow", {
  organizationId: __t.string(),
  organizationName: __t.string(),
  isInGracePeriod: __t.bool(),
  get subscriptions() {
    return __t.array(LicenseSubRow);
  },
});
export type LicenseLookupRow = __Infer<typeof LicenseLookupRow>;

export const LicenseSubRow = __t.object("LicenseSubRow", {
  id: __t.string(),
  status: __t.string(),
  productId: __t.string(),
  priceId: __t.string(),
  quantity: __t.i32(),
  cancelAt: __t.option(__t.timestamp()),
  canceledAt: __t.option(__t.timestamp()),
});
export type LicenseSubRow = __Infer<typeof LicenseSubRow>;

export const MemberImportRow = __t.object("MemberImportRow", {
  id: __t.string(),
  userId: __t.string(),
  organizationId: __t.string(),
  inviterId: __t.string(),
  inviteToken: __t.string(),
  isPowerOnProPlus: __t.bool(),
  role: __t.string(),
  status: __t.string(),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type MemberImportRow = __Infer<typeof MemberImportRow>;

export const Members = __t.object("Members", {
  id: __t.string(),
  userId: __t.string(),
  organizationId: __t.string(),
  inviterId: __t.string(),
  inviteToken: __t.string(),
  isPowerOnProPlus: __t.bool(),
  role: __t.string(),
  status: __t.string(),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type Members = __Infer<typeof Members>;

export const ModuleConfig = __t.object("ModuleConfig", {
  id: __t.string(),
  ownerIdentity: __t.identity(),
  schemaVersion: __t.string(),
  serviceIdentity: __t.option(__t.identity()),
});
export type ModuleConfig = __Infer<typeof ModuleConfig>;

export const MyMemberships = __t.object("MyMemberships", {});
export type MyMemberships = __Infer<typeof MyMemberships>;

export const MyOrganizations = __t.object("MyOrganizations", {});
export type MyOrganizations = __Infer<typeof MyOrganizations>;

export const MyPendingOrgs = __t.object("MyPendingOrgs", {});
export type MyPendingOrgs = __Infer<typeof MyPendingOrgs>;

export const MyUser = __t.object("MyUser", {});
export type MyUser = __Infer<typeof MyUser>;

export const OpportunityAcceptPlaybookImportRow = __t.object("OpportunityAcceptPlaybookImportRow", {
  id: __t.string(),
  organizationId: __t.string(),
  opportunityId: __t.string(),
  playbookId: __t.string(),
});
export type OpportunityAcceptPlaybookImportRow = __Infer<typeof OpportunityAcceptPlaybookImportRow>;

export const OpportunityAcceptPlaybooks = __t.object("OpportunityAcceptPlaybooks", {
  id: __t.string(),
  organizationId: __t.string(),
  opportunityId: __t.string(),
  playbookId: __t.string(),
});
export type OpportunityAcceptPlaybooks = __Infer<typeof OpportunityAcceptPlaybooks>;

export const OpportunityTagImportRow = __t.object("OpportunityTagImportRow", {
  id: __t.string(),
  organizationId: __t.string(),
  opportunityId: __t.string(),
  tagId: __t.string(),
});
export type OpportunityTagImportRow = __Infer<typeof OpportunityTagImportRow>;

export const OpportunityTags = __t.object("OpportunityTags", {
  id: __t.string(),
  organizationId: __t.string(),
  opportunityId: __t.string(),
  tagId: __t.string(),
});
export type OpportunityTags = __Infer<typeof OpportunityTags>;

export const OrgApiKeyRow = __t.object("OrgApiKeyRow", {
  id: __t.string(),
  organizationId: __t.string(),
  userId: __t.string(),
  product: __t.string(),
  apiKey: __t.string(),
  isPowerOnProPlus: __t.option(__t.bool()),
  createdAt: __t.option(__t.timestamp()),
});
export type OrgApiKeyRow = __Infer<typeof OrgApiKeyRow>;

export const OrgApiKeys = __t.object("OrgApiKeys", {});
export type OrgApiKeys = __Infer<typeof OrgApiKeys>;

export const OrgGlaciSync = __t.object("OrgGlaciSync", {});
export type OrgGlaciSync = __Infer<typeof OrgGlaciSync>;

export const OrgGlaciTags = __t.object("OrgGlaciTags", {});
export type OrgGlaciTags = __Infer<typeof OrgGlaciTags>;

export const OrgMemberRow = __t.object("OrgMemberRow", {
  id: __t.string(),
  userId: __t.string(),
  organizationId: __t.string(),
  inviterId: __t.string(),
  isPowerOnProPlus: __t.bool(),
  role: __t.string(),
  status: __t.string(),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type OrgMemberRow = __Infer<typeof OrgMemberRow>;

export const OrgMembers = __t.object("OrgMembers", {});
export type OrgMembers = __Infer<typeof OrgMembers>;

export const OrgOpportunities = __t.object("OrgOpportunities", {});
export type OrgOpportunities = __Infer<typeof OrgOpportunities>;

export const OrgOpportunityAcceptPlaybooks = __t.object("OrgOpportunityAcceptPlaybooks", {});
export type OrgOpportunityAcceptPlaybooks = __Infer<typeof OrgOpportunityAcceptPlaybooks>;

export const OrgOpportunityTags = __t.object("OrgOpportunityTags", {});
export type OrgOpportunityTags = __Infer<typeof OrgOpportunityTags>;

export const OrgPlaybookSync = __t.object("OrgPlaybookSync", {});
export type OrgPlaybookSync = __Infer<typeof OrgPlaybookSync>;

export const OrgPlaybookTags = __t.object("OrgPlaybookTags", {});
export type OrgPlaybookTags = __Infer<typeof OrgPlaybookTags>;

export const OrgPlaybooks = __t.object("OrgPlaybooks", {});
export type OrgPlaybooks = __Infer<typeof OrgPlaybooks>;

export const OrgSubscriptions = __t.object("OrgSubscriptions", {});
export type OrgSubscriptions = __Infer<typeof OrgSubscriptions>;

export const OrgTaxExemptions = __t.object("OrgTaxExemptions", {});
export type OrgTaxExemptions = __Infer<typeof OrgTaxExemptions>;

export const OrgUserRow = __t.object("OrgUserRow", {
  id: __t.string(),
  name: __t.string(),
  email: __t.string(),
  avatar: __t.string(),
  lastSignInAt: __t.option(__t.timestamp()),
});
export type OrgUserRow = __Infer<typeof OrgUserRow>;

export const OrgUsers = __t.object("OrgUsers", {});
export type OrgUsers = __Infer<typeof OrgUsers>;

export const OrganizationImportRow = __t.object("OrganizationImportRow", {
  id: __t.string(),
  name: __t.string(),
  ownerId: __t.string(),
  customerId: __t.string(),
  logo: __t.string(),
  isGlaciEnabled: __t.option(__t.bool()),
  isInGracePeriod: __t.option(__t.bool()),
  hasRequestedGlaciAccess: __t.option(__t.bool()),
  runtimeUri: __t.option(__t.string()),
  runtimeModule: __t.option(__t.string()),
  glaciContextCatalog: __t.option(__t.string()),
  glaciFeatures: __t.option(__t.string()),
  glaciInstances: __t.option(__t.string()),
  glaciBranding: __t.option(__t.string()),
  glaciCredentialMetadata: __t.option(__t.string()),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type OrganizationImportRow = __Infer<typeof OrganizationImportRow>;

export const Organizations = __t.object("Organizations", {
  id: __t.string(),
  name: __t.string(),
  ownerId: __t.string(),
  customerId: __t.string(),
  logo: __t.string(),
  isGlaciEnabled: __t.option(__t.bool()),
  isInGracePeriod: __t.option(__t.bool()),
  hasRequestedGlaciAccess: __t.option(__t.bool()),
  runtimeUri: __t.option(__t.string()),
  runtimeModule: __t.option(__t.string()),
  glaciContextCatalog: __t.option(__t.string()),
  glaciFeatures: __t.option(__t.string()),
  glaciInstances: __t.option(__t.string()),
  glaciBranding: __t.option(__t.string()),
  glaciCredentialMetadata: __t.option(__t.string()),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type Organizations = __Infer<typeof Organizations>;

export const PendingOrgRow = __t.object("PendingOrgRow", {
  id: __t.string(),
  name: __t.string(),
  logo: __t.string(),
});
export type PendingOrgRow = __Infer<typeof PendingOrgRow>;

export const PlaybookTagImportRow = __t.object("PlaybookTagImportRow", {
  id: __t.string(),
  organizationId: __t.string(),
  playbookId: __t.string(),
  tagId: __t.string(),
});
export type PlaybookTagImportRow = __Infer<typeof PlaybookTagImportRow>;

export const PlaybookTags = __t.object("PlaybookTags", {
  id: __t.string(),
  organizationId: __t.string(),
  playbookId: __t.string(),
  tagId: __t.string(),
});
export type PlaybookTags = __Infer<typeof PlaybookTags>;

export const PortalAuthConfig = __t.object("PortalAuthConfig", {
  id: __t.string(),
  issuer: __t.string(),
});
export type PortalAuthConfig = __Infer<typeof PortalAuthConfig>;

export const StaffTaxApplication = __t.object("StaffTaxApplication", {
  id: __t.string(),
  organizationName: __t.string(),
  status: __t.string(),
  needsAttention: __t.bool(),
  updatedAt: __t.option(__t.timestamp()),
});
export type StaffTaxApplication = __Infer<typeof StaffTaxApplication>;

export const StaffTaxApplications = __t.object("StaffTaxApplications", {});
export type StaffTaxApplications = __Infer<typeof StaffTaxApplications>;

export const SubscriptionImportRow = __t.object("SubscriptionImportRow", {
  id: __t.string(),
  organizationId: __t.string(),
  customerId: __t.string(),
  productId: __t.string(),
  priceId: __t.string(),
  status: __t.string(),
  quantity: __t.i32(),
  cancelAt: __t.option(__t.timestamp()),
  canceledAt: __t.option(__t.timestamp()),
  cancelAtPeriodEnd: __t.bool(),
  collectionMethod: __t.string(),
  lastEventAt: __t.timestamp(),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type SubscriptionImportRow = __Infer<typeof SubscriptionImportRow>;

export const Subscriptions = __t.object("Subscriptions", {
  id: __t.string(),
  organizationId: __t.string(),
  customerId: __t.string(),
  productId: __t.string(),
  priceId: __t.string(),
  status: __t.string(),
  quantity: __t.i32(),
  cancelAt: __t.option(__t.timestamp()),
  canceledAt: __t.option(__t.timestamp()),
  cancelAtPeriodEnd: __t.bool(),
  collectionMethod: __t.string(),
  lastEventAt: __t.timestamp(),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type Subscriptions = __Infer<typeof Subscriptions>;

export const SvcGlaciPlaybooks = __t.object("SvcGlaciPlaybooks", {});
export type SvcGlaciPlaybooks = __Infer<typeof SvcGlaciPlaybooks>;

export const SvcGlaciTags = __t.object("SvcGlaciTags", {});
export type SvcGlaciTags = __Infer<typeof SvcGlaciTags>;

export const SvcOrganization = __t.object("SvcOrganization", {
  id: __t.string(),
  name: __t.string(),
  logo: __t.string(),
  isGlaciEnabled: __t.option(__t.bool()),
  runtimeUri: __t.option(__t.string()),
  runtimeModule: __t.option(__t.string()),
  glaciFeatures: __t.option(__t.string()),
  glaciBranding: __t.option(__t.string()),
  glaciInstances: __t.option(__t.string()),
  glaciContextCatalog: __t.option(__t.string()),
  updatedAt: __t.option(__t.timestamp()),
});
export type SvcOrganization = __Infer<typeof SvcOrganization>;

export const SvcOrganizations = __t.object("SvcOrganizations", {});
export type SvcOrganizations = __Infer<typeof SvcOrganizations>;

export const SvcPlaybookTags = __t.object("SvcPlaybookTags", {});
export type SvcPlaybookTags = __Infer<typeof SvcPlaybookTags>;

export const TaxExemptionImportRow = __t.object("TaxExemptionImportRow", {
  id: __t.string(),
  userId: __t.string(),
  organizationId: __t.string(),
  companyName: __t.string(),
  billingEmail: __t.string(),
  addressLine1: __t.string(),
  addressLine2: __t.string(),
  city: __t.string(),
  state: __t.string(),
  postalCode: __t.string(),
  certificateKey: __t.string(),
  status: __t.string(),
  updatedAt: __t.option(__t.timestamp()),
});
export type TaxExemptionImportRow = __Infer<typeof TaxExemptionImportRow>;

export const TaxExemptions = __t.object("TaxExemptions", {
  id: __t.string(),
  userId: __t.string(),
  organizationId: __t.string(),
  companyName: __t.string(),
  billingEmail: __t.string(),
  addressLine1: __t.string(),
  addressLine2: __t.string(),
  city: __t.string(),
  state: __t.string(),
  postalCode: __t.string(),
  certificateKey: __t.string(),
  status: __t.string(),
  updatedAt: __t.option(__t.timestamp()),
});
export type TaxExemptions = __Infer<typeof TaxExemptions>;

export const TaxReviews = __t.object("TaxReviews", {
  id: __t.string(),
  organizationId: __t.string(),
  reviewerId: __t.string(),
  reviewedAt: __t.timestamp(),
  approvedBy: __t.string(),
  approvedAt: __t.option(__t.timestamp()),
  originalCustomerId: __t.string(),
  customerId: __t.string(),
  creationStartedAt: __t.option(__t.timestamp()),
  operationId: __t.string(),
  operationAt: __t.option(__t.timestamp()),
  emailSentAt: __t.option(__t.timestamp()),
  emailOperationId: __t.string(),
  emailOperationAt: __t.option(__t.timestamp()),
});
export type TaxReviews = __Infer<typeof TaxReviews>;

export const UserImportRow = __t.object("UserImportRow", {
  id: __t.string(),
  email: __t.string(),
  name: __t.string(),
  avatar: __t.string(),
  lastSelectedOrganizationId: __t.option(__t.string()),
  lastSignInAt: __t.option(__t.timestamp()),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type UserImportRow = __Infer<typeof UserImportRow>;

export const Users = __t.object("Users", {
  id: __t.string(),
  email: __t.string(),
  name: __t.string(),
  avatar: __t.string(),
  lastSelectedOrganizationId: __t.option(__t.string()),
  lastSignInAt: __t.option(__t.timestamp()),
  createdAt: __t.option(__t.timestamp()),
  updatedAt: __t.option(__t.timestamp()),
});
export type Users = __Infer<typeof Users>;

